import './style.scss';

export function text_block() {
  const block = document.querySelector('.text_block');
  if (!block) return;
  
}
